import { ReactElement } from 'react';
import { Link } from '@appsumo/dorado-react';

import Guarantee from '~/components/checkout/Global/Guarantee';

export default function CheckoutTrust(): ReactElement {
  return (
    <>
      <div className="text-xs text-grace">
        By clicking the &ldquo;Place order now&ldquo; button, you confirm that
        you have read, understand, and accept our&nbsp;
        <Link href="https://appsumo.com/terms-of-use/" styled>
          Terms and Conditions
        </Link>
        &nbsp;and&nbsp;
        <Link href="https://appsumo.com/privacy/" styled>
          Privacy Policy
        </Link>
        .
        <br />
        <br />
        Need help?&nbsp;
        <Link href="https://help.appsumo.com/" styled>
          Reach out to our support team
        </Link>
        &nbsp;with any questions you may have.
      </div>
      <Guarantee />
    </>
  );
}
